/* PeakFlex: keeps free-gift cart lines (property _pf_gift = main product id) tied to their main product.
   Removes gifts whose main product left the cart and keeps each gift at quantity 1. */
(function () {
  if (window.__pfGiftSync) return;
  window.__pfGiftSync = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var script = document.currentScript;
  var hasGiftOnLoad = !script || script.getAttribute('data-has-gift') === 'true';
  var busy = false;
  var again = false;

  function renderDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !data.sections || typeof drawer.getSectionsToRender !== 'function') return false;
    drawer.getSectionsToRender().forEach(function (s) {
      var html = data.sections[s.id];
      if (!html) return;
      var target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      var source = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector || '.shopify-section');
      if (target && source) target.innerHTML = source.innerHTML;
    });
    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
    drawer.classList.toggle('is-empty', data.item_count === 0);
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.toggle('is-empty', data.item_count === 0);
    return true;
  }

  function check() {
    if (busy) { again = true; return; }
    busy = true;
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var mains = {};
        (cart.items || []).forEach(function (item) {
          if (!(item.properties && item.properties._pf_gift)) mains[String(item.product_id)] = true;
        });
        var updates = {};
        var count = 0;
        (cart.items || []).forEach(function (item) {
          var owner = item.properties && item.properties._pf_gift;
          if (!owner) return;
          if (!mains[String(owner)]) { updates[item.key] = 0; count++; }
          else if (item.quantity > 1) { updates[item.key] = 1; count++; }
        });
        if (!count) return null;
        var body = { updates: updates };
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        return fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            renderDrawer(data);
            if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
          });
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; check(); }
      });
  }

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'pflb-offer') return;
        check();
      });
    }
    if (hasGiftOnLoad) check();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
